import React, { useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux'

import QuickMain from '../../presentation/section/quick-page/QuickMain';
import QuickResult from '../../presentation/section/quick-page/QuickResult';
import QuickSearchBar from '../../presentation/section/quick-page/QuickSearchBar';
import { postExpress } from '../../../service/api';
import JSONtoChartData from '../json-to-chartdata/JSONtoChartData';
import { QUICK_RANGE } from '../../../config/CalendarRangeSet';

import * as path from '../../../route/PathConfig';


const getDefaultDateRange = () => {
  const today = new Date();
  const startDate = new Date();
  const aWeekAgoDate = new Date();
  startDate.setDate(today.getDate()-1);
  aWeekAgoDate.setDate(today.getDate()-7);
  return [aWeekAgoDate, startDate];
}

// const Quick = React.memo((props) => {
const Quick = (props) => {
  const [keyword, setKeyword] = useState('');
  const [dateRange, setDate] = useState(getDefaultDateRange());
  const [mainData, setMainData] = useState({
    loaded: false,
    mainData: []
  });
  const [selectedData, setSelectedData] = useState(null);

  const [lineData, setLineData] = useState({
    loaded: false,
    lineData: [],
  });
  const [relationMapData, setRelationMapData] = useState({
    loaded: false,
    relationMapData: []
  });

  const [searchedBasicData, setSearchedBasicData] = useState({
    loaded: false,
    lineData: null,
    totalPost: "LOADING",
    dailyPost: "LOADING"
  });
  const [searchedSentiData, setSearchedSentiData] = useState({
    loaded: false,
    pieData: null,
    sentimentBarData: null
  });
  const [searchedRelationData, setSearchedRelationData] = useState({
    loaded: false,
    wordcloudData: null,
    categoryMapData: null
  })
  useEffect(() => {
    getQuickMainData(
      (result)=>{
        setMainData({
          loaded: true,
          mainData: result.quick
        })
        setSelectedData(result.quick['trend-list'][0]);
      }
    )
  }, []);

  useEffect(() => {
    if (selectedData){
      setLineData({
        loaded: false,
        lineData: [], 
      });
      setRelationMapData({
        loaded: false,
        relationMapData: []
      });

      setLineData({
        loaded: true,
        lineData: JSONtoChartData({data:selectedData, type:"quick-line"})
      })
      setRelationMapData({
        loaded: true,
        relationMapData: JSONtoChartData({data:selectedData, type:"relationMap"})
      })
    }
  }, [selectedData])

  const getQuickMainData = (callback) => {
    postExpress('/quick/main', {
      "keyword": "quick-main"
    }, (res)=>{
      callback(res.data);
    });
  }

  const getQuickSearchData = (callback) => {
    postExpress('/quick/keyword/basic', ({
      "keyword": keyword,
      "dateRange": [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
      (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")]
    }), (res) => {
      callback(res.data.report_data);
    })
    postExpress('/quick/keyword/sentiment', ({
      "keyword": keyword,
      "dateRange": [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
      (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")]
    }), (res)=> {
      callback(res.data.report_data);
    })
    postExpress('/quick/keyword/conversation', ({
      "keyword": keyword,
      "dateRange": [(dateRange[0].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "") ,
      (dateRange[1].toLocaleDateString("ja-JP",{year:"numeric", day:"2-digit", month:"2-digit"})).replace(/\//g, "")]
    }), (res)=> {
      callback(res.data.report_data)
    })
  }

  const handleDate = (selectedDateRange) => {
    setDate(selectedDateRange)
  }

  const handleKeyword = (event) => {
    setKeyword(event.target.value)
  }

  const handleKeyPress = (event) => {
    if(event.charCode === 13) {
      handleSearchBtn();
    }
  }

  const handleSearchBtn = () => {
    setSearchedBasicData({
      loaded: false,
      lineData: null,
      totalPost: "LOADING",
      dailyPost: "LOADING"
    })
    setSearchedSentiData({
      loaded: false,
      pieData: null,
      sentimentBarData: null,
    })
    setSearchedRelationData({
      loaded: false,
      wordcloudData: null,
      categoryMapData: null
    })

    const { history } = props;
    // history.push(`/new/quick/keyword`);
    history.push(path.QUICKRESULT);

    getQuickSearchData(
      (result)=>{
        if (result.report_type == "basic"){
          let basicDataSet = {
            loaded: true,
            lineData: null,
            totalPost: "LOADING",
            dailyPost: "LOADING"
          }
          
          basicDataSet.lineData = JSONtoChartData({data:{basic: result.data, dateRange:result.dateRange}, type:"quick-result-line"});
          basicDataSet.totalPost = `${result.data.all_count.toLocaleString(undefined)} 건`;
          basicDataSet.dailyPost = `${result.data.avg_count.toLocaleString(undefined)} 건`;
          setSearchedBasicData(basicDataSet);
        }
        else if (result.report_type == "sentiment"){
          let sentiDataSet = {
            loaded: true,
            pieData: null,
            sentimentBarData: null
          }

          sentiDataSet.pieData = JSONtoChartData({data:result.data[0], type:"quick-result-sentimentPie"});
          sentiDataSet.sentimentBarData = JSONtoChartData({data:result.data[0], type:"quick-result-sentimentBar"});
          setSearchedSentiData(sentiDataSet);
        }
        else if (result.report_type == "relation"){
          let relationDataSet = {
            loaded: true,
            wordcloudData: null,
            categoryMapData: null
          }

          relationDataSet.wordcloudData = JSONtoChartData({data:{relation: result.data.conversation.resolvedData2[0].all.data,maxWords: 100},type:"quick-result-relationMap"})
          relationDataSet.categoryMapData = JSONtoChartData({data:{relation: result.data.category.resolvedData3[0].content, info: result.data.category.resolvedData3[0].info}, type:"quick-result-categoryMap"});
          setSearchedRelationData(relationDataSet);
        }
      }
    )
  }

  const selectData = (data) => {
    setSelectedData(data);
  }
  return (
    <>
      <QuickSearchBar 
        calendarOnChange={handleDate} calendarValue={dateRange} 
        inputOnChange={handleKeyword} inputOnKeyPress={handleKeyPress} inputValue={keyword}
        btnOnClick={handleSearchBtn} minDate={QUICK_RANGE()}
        currentUser={props.currentUser}
      />
      <Switch>
        <Route exact path={path.QUICK}
          render={props=>
            <QuickMain {...props}
            handleOnClick={selectData}
            data={mainData}
            mapData={relationMapData}
            lineData={lineData}
            />
          }
        />
        <Route path={`${path.QUICKRESULT}`}
          render={props=>
            <QuickResult {...props}
              searchedBasicData={searchedBasicData}
              searchedSentiData={searchedSentiData}
              searchedRelationData={searchedRelationData}
            />
          }
        />
      </Switch> 

      {/* {React.useMemo(()=>{
        return(
          <Switch>
            <Route exact path={path.QUICK}
              render={props=>
                <QuickMain {...props}
                handleOnClick={selectData}
                data={mainData}
                mapData={relationMapData}
                lineData={lineData}
                />
              }
            />
            <Route path={`${path.QUICKRESULT}`}
              render={props=>
                <QuickResult {...props}
                  // searchedData={searchedData}
                  searchedBasicData={searchedBasicData}
                  searchedSentiData={searchedSentiData}
                  searchedRelationData={searchedRelationData}
                />
              }
            />
          </Switch> 
        )
      }, [lineData, relationMapData, searchedRelationData, searchedBasicData,searchedSentiData])} */}
    </>
  )
    }
// })

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});
export default connect(mapStateToProps) (Quick);